import { render, staticRenderFns } from "./DataItem.vue?vue&type=template&id=fcba0996"
import script from "./DataItem.vue?vue&type=script&lang=js"
export * from "./DataItem.vue?vue&type=script&lang=js"
import style0 from "./DataItem.vue?vue&type=style&index=0&id=fcba0996&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports